module.exports = __webpack_public_path__ + "static/img/color-palette-9.60026b9b.svg";